import { Button, Card, Flex, Space, Tag, Typography, theme } from 'antd';
import { FC } from 'react';
import { PencilSquare } from 'react-bootstrap-icons';
import { Link } from 'react-router-dom';

import { AppRoutes } from '@/common/interfaces';
import { CommonContainerTitle } from '@/common/layouts';

import { SiteGroup, SiteGroupsDeleteButton } from '@/modules/SiteGroups';

import { SiteGroupsSearchAnalytics } from '../SiteGroupsSearchAnalytics';

interface Props {
  siteGroup: SiteGroup;
  disableButtons: boolean;
  handleBack: () => void;
  handleDeletedSiteGroup: () => void;
  handleEditSiteGroup: () => void;
}

export const SiteGroupsOverviewView: FC<Props> = ({
  siteGroup,
  disableButtons,
  handleBack,
  handleDeletedSiteGroup,
  handleEditSiteGroup
}) => {
  const { token } = theme.useToken();

  return (
    <>
      <CommonContainerTitle
        onBack={ handleBack }
        extra={
          <Space>
            <Button disabled={ disableButtons } icon={ <PencilSquare/> } onClick={ handleEditSiteGroup }>
              Редагувати
            </Button>
            <SiteGroupsDeleteButton
              siteGroupId={ siteGroup.id }
              disabled={ disableButtons }
              handleDeleted={ handleDeletedSiteGroup }
            />
          </Space>
        }
      >
        <Typography.Title level={ 3 } style={{ marginBottom: 0 }}>
          { siteGroup.name }
        </Typography.Title>
      </CommonContainerTitle>

      <Flex vertical gap={ token.margin }>
        <Card
          title="Сайти"
          extra={ <Tag color="blue">{siteGroup.sites.length}</Tag> }
        >
          <Flex wrap gap={ 4 }>
            { siteGroup.sites.map((site) => (
              <Link key={ site.id } to={ AppRoutes.SitesById.replace(':siteId', site.id) }>
                <Tag style={{ margin: 0, cursor: 'pointer' }}>{ site.name }</Tag>
              </Link>
            )) }
          </Flex>
        </Card>

        <Card title="Search Analytics">
          { /* remount on sites change: drops the old result and a request still running for the previous state */ }
          <SiteGroupsSearchAnalytics
            key={ `${ siteGroup.id }:${ siteGroup.sites.map(({ id }) => id).join() }` }
            siteGroupId={ siteGroup.id }
          />
        </Card>
      </Flex>
    </>
  );
};
